import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

class HtmlArrowTooltip extends Component {
//   const { arrow, ...classes } = useStylesArrow();

  constructor(props) {
    super(props);
    this.state = {
      top: 0,
      left: 0,
    };

    this.parentTooltipRef = React.createRef();
  }

  componentDidMount() {
    this.updateParentLocation();

    window.addEventListener('resize', this.updateParentLocation);
  }

  componentWillReceiveProps(){
    this.updateParentLocation();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateParentLocation);
  }

  updateParentLocation = () => {
    if (this.parentTooltipRef.current) {
      this.setState({
        left: this.parentTooltipRef.current.offsetLeft - ((this.parentTooltipRef.current.offsetWidth / 2) + 20),
        top: this.parentTooltipRef.current.offsetTop + this.parentTooltipRef.current.offsetHeight,
      });
    }
  }

  handleClickAway = () => {
    if (this.props.open) {
      this.props.onClose();
    }
  };

  render() {
    // const [arrowRef, setArrowRef] = React.useState(null);
    const { classes } = this.props;

    const content = this.props.open && this.parentTooltipRef.current
    ? (
      <div
        className={classes.tooltipContainer} style={{
          left: this.state.left,
          top: this.state.top,
        }}
      >
        <div className={classes.tooltipContent}>
          {this.props.title}
        </div>
        <div
          className={classes.tooltipArrow}
        >
          <span className={classes.tooptipSpan}>
            <svg width="32" height="16" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <polygon points="32,16 16,0 0,16" fill="#fff" />
            </svg>
          </span>
        </div>


      </div>
    )
    : null;


    return (
      <ClickAwayListener onClickAway={this.handleClickAway}>
        <div ref={this.parentTooltipRef}>
          {this.props.children}
          {content}
        </div>
      </ClickAwayListener>
    );
  }
}


const styles = theme => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 1)',
    minWidth: 300,
    maxWidth: 500,
    fontSize: 12,
    marginTop: 13,
    border: '1px solid #dadde9',
  },
  tooltipContainer: {
    display: 'inline-block',
    filter: 'drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 3px)',
    maxWidth: '100%',
    opacity: 1,
    position: 'absolute',
    zIndex: 10000,
    // padding: 16,
    // right: 10,
    marginTop: 5,
  },
  tooltipArrow: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: 16,
    top: 0,
    justifyContent: 'center',
    display: 'flex',
  },
  tooltipSpan: {
    display: 'inline-flex',
    position: 'absolut',
    marginLeft: 8,
    marginRight: 8,
    left: 166,
  },
  tooltipContent: {
    backgroundColor: 'white',
    borderRadius: 5,
    boxSizing: 'border-box',
    color: 'black',
    fontSize: 16,
    maxWidth: '100%',
    padding: 15,
    position: 'relative',
    // width: 380,
  },
  arrow: {
    position: 'absolute',
    backgroundColor: '#FFF',
    opacity: 1,
    fontSize: 12,
    '&::before': {
      content: '""',
      margin: 'auto',
      borderColor: '#dadde9',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  // popper: arrowGenerator('rgba(0, 0, 0, 1)', '#dadde9'),
});


export default withStyles(styles)(HtmlArrowTooltip);



// WEBPACK FOOTER //
// ./src/app/components/tooltip/html-tooltip.js